<!-- Uploader.vue -->

<!-- HTML Template -->
<template>
    <div class="self-uploader-container">
      <template v-if="showPhoto">
        <div class="self-uploader-container__uploaded-photo-wrap">
            <img class="self-uploader-container__uploaded-photo-wrap__thumb" :src="getThumbnail(photo_data)">
            <div class="photo-component__buttons">
              <template v-if="has_crop">
                <div class="photo-component__buttons-container">
                  <a @click="previewPhoto(photo_data)" class="button button-m button-outline-white">{{ $t('common.preview') }}</a>
                  <a @click="showCrop()" class="button button-m button-outline-white photo-component__crop-button">{{ $t('common.crop_and_resize') }}</a>
                </div>
              </template>
              <template v-else>
                <a @click="previewPhoto(photo_data)" class="button button-m button-outline-white photo-component__button-center">{{ $t('common.preview') }}</a>
              </template>
              <a class="delete" @click="deletePhoto(photo_data.id)"><img src="/img/bin.svg" alt="delete"></a>
            </div>
        </div>
      </template>
      <template v-else>
        <form enctype="multipart/form-data" novalidate>
            <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept=".jpg,.jpeg,.gif,.png" class="input-file">
        </form>

        <div class="add-photo__text-container">
            <div class="add-photo__plus"><img src="/img/add.svg" alt=""></div>
            <p class="text-center subtitle text-secondary" v-if="isInitial">
            {{ upload_description }}
            </p>
            <p class="text-center subtitle text-secondary" v-if="isSaving">
            Uploading file...
            </p>
            <p class="text-center subtitle text-secondary" v-if="isFailed">
            Upload failed...
            </p>
            <p class="text-center subtitle text-secondary" v-if="isSuccess">
            uploaded
            </p>
        </div>
      </template>
    </div>
</template>

<!-- Javascript -->
<script>
  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  const TYPE_HERO_PHOTO = 'hero_photo';
  const TYPE_COMPANY_LOGO = 'company_logo';
  const TYPE_OVERVIEW_PHOTO_FIRST = 'overview_photo_first';
  const TYPE_OVERVIEW_PHOTO_SECOND = 'overview_photo_second';
  const TYPE_AGENT_PROFILE_PHOTO = 'agent_profile_photo';
  const TYPE_CO_AGENT_PROFILE_PHOTO = 'co_agent_profile_photo';
  const TYPE_LISTING_AGENT_PROFILE_PHOTO = 'listing_agent_profile_photo';

  const EMPTY_PHOTO = {
    'full_path': null,
    'id': null,
  }

  export default {
    name: 'uploader',
    props: {
        has_crop: {
            type: Boolean,
            default: false
        },
        listing_id: Number,
        upload_description: String,
        type: String,
        photo_data: Object
    },
    data() {
      return {
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'photo',
        photo: EMPTY_PHOTO
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      showPhoto() {
        return this.photo_data ? true : false;
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL;
        this.uploadError = null;
      },
      getUrl() {
        return `${this.getUri()}/${this.listing_id}`
      },
      getUri() {
        switch(this.type) {
          case TYPE_HERO_PHOTO:
            return '/api/photos/upload-hero-photo';
            break;
          case TYPE_COMPANY_LOGO:
            return '/api/photos/upload-company-logo';
            break;
          case TYPE_OVERVIEW_PHOTO_FIRST:
            return '/api/photos/upload-overview-photo-first';
            break;
          case TYPE_OVERVIEW_PHOTO_SECOND:
            return '/api/photos/upload-overview-photo-second';
            break;
          case TYPE_AGENT_PROFILE_PHOTO:
            return '/api/photos/upload-agent-profile-photo/agent';
            break;
          case TYPE_CO_AGENT_PROFILE_PHOTO:
            return '/api/photos/upload-agent-profile-photo/co-agent';
            break;
          case TYPE_LISTING_AGENT_PROFILE_PHOTO:
            return '/api/photos/upload-agent-profile-photo/listing-agent';
            break;
        }
      },
      getDeletePhotoType() {
        switch(this.type) {
          case TYPE_HERO_PHOTO:
            return DELETE_HERO_PHOTO;
            break;
          case TYPE_COMPANY_LOGO:
            return DELETE_COMPANY_LOGO;
            break;
          case TYPE_OVERVIEW_PHOTO_FIRST:
            return DELETE_OVERVIEW_PHOTO_FIRST;
            break;
          case TYPE_OVERVIEW_PHOTO_SECOND:
            return DELETE_OVERVIEW_PHOTO_SECOND;
            break;
          case TYPE_AGENT_PROFILE_PHOTO:
            return DELETE_AGENT_PROFILE_PHOTO;
            break;
          case TYPE_CO_AGENT_PROFILE_PHOTO:
            return DELETE_CO_AGENT_PROFILE_PHOTO;
            break;
          case TYPE_LISTING_AGENT_PROFILE_PHOTO:
            return DELETE_LISTING_AGENT_PROFILE_PHOTO;
            break;
        }
      },
      upload(formData) {
        let url = this.getUrl()
        return axios.post(url, formData)
            // get data
            .then(function (response) {
                this.$root.$emit('set_photo', this.type, response.data.data.photo)
            }.bind(this));
      },
      save(formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING;

        this.upload(formData)
          .then(x => {
            this.currentStatus = STATUS_SUCCESS;
          })
          .catch(err => {
            console.log(err);
            this.uploadError = err.response;
            this.currentStatus = STATUS_FAILED;
          });
      },
      filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData();

        if (!fileList.length) return;
        // append the files to FormData
        
        formData.append(fieldName, fileList[0], fileList[0].name);

        // save it
        this.save(formData);
      },
      deletePhoto(id) {
        this.$root.$emit('show_confirmation', {
            'title': this.$t('common.remove_photo'),
            'description': this.$t('common.are_you_sure'),
            'type': this.getDeletePhotoType(),
            'data': {
                'id': id
            },
            'button_text': this.$t('common.remove')
        });
      },
      previewPhoto(photo) {
          this.$root.$emit('preview_photo', photo);
      },
      showCrop() {
        this.$root.$emit('show_crop', this.type, this.photo_data)
      },
      getThumbnail(photo) {
        return photo.thumb_path ? photo.thumb_path : photo.full_path;
      },
    },
    mounted() {
      this.reset();

      this.$root.$on('confirmed', (type, data) => {
          if (type == this.getDeletePhotoType()) {
              let url =  `/api/photos/delete/${this.listing_id}`;

              axios.delete(url, {data : {id: data.id}}).then(function (response) {
                  console.log('deleted');
              }).then(function(response) {
                  this.$root.$emit('set_photo', this.type, null)
    
                  this.reset();
              }.bind(this));
          }
      })
    },
    watch: {
    }
  }

</script>
